module.exports = __webpack_public_path__ + "static/tech-c2deadf63bfe3176bc9adb9a2ce1f929.jpg";